import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import TuckingQuestion from '@/views/v2/apps/TuckingQuestion.vue';
import SampleNetPayComputationDialog from '@/views/v2/apps/SampleNetPayComputationDialog.vue';
import ProductListDialog from '@/views/v2/apps/ProductListDialog.vue';
import TuckingMdrApplyConfirmDialog from '@/views/v2/apps/TuckingMdrApplyConfirmDialog.vue';
import UpdateAppMdrApplied from '@/plugins/graphql/mutations/v2/update-app-mdr-applied.gql';
let TuckingInMdrDialog = class TuckingInMdrDialog extends Mixins() {
    included() {
        const vm = this;
        vm.confirmYes = !vm.confirmYes;
        vm.hideDialog = !vm.hideDialog;
    }
    notIncluded() {
        const vm = this;
        vm.confirmYes = !vm.confirmYes;
        vm.beginSetup = !vm.beginSetup;
    }
    async updateAppMdr() {
        await this.$apollo.mutate({
            mutation: UpdateAppMdrApplied,
            variables: {
                input: {
                    appUuid: this.appUuid,
                },
            },
        });
        this.$emit('close');
    }
    setupConfirm() {
        const vm = this;
        vm.confirmedSetup = !vm.confirmedSetup;
        vm.beginSetup = !vm.beginSetup;
    }
    declineFromSetup() {
        const vm = this;
        vm.beginSetup = !vm.beginSetup;
        vm.hideDialog = !vm.hideDialog;
    }
};
__decorate([
    Prop({ type: String, required: true })
], TuckingInMdrDialog.prototype, "appUuid", void 0);
TuckingInMdrDialog = __decorate([
    Component({
        components: {
            SampleNetPayComputationDialog,
            TuckingQuestion,
            ProductListDialog,
            TuckingMdrApplyConfirmDialog,
        },
        data() {
            return {
                confirmYes: false,
                beginSetup: false,
                confirmedSetup: false,
                hideDialog: false,
            };
        },
    })
], TuckingInMdrDialog);
export default TuckingInMdrDialog;
